import * as d3 from "d3"

let DOMtarget, vizWitdh, vizHeigth
let dimensions, wrapper, bounds, peripherals
let dataset = []
let defs, gradientId
let cloudOffset, precipitationOffset, UvOffset, uvIndexThresholdVeryHigh, uvIndexThresholdHigh
let radiusScale, precipitationTypes, precipitationTypeColorScale
// animated objects
let freezingCircle



// Export Function for Vue.js
export function drawRadialChart(theDataSet, c, d, e) {
    DOMtarget = c;
    vizWitdh = d;
    vizHeigth = e;

    setDimensions()
    drawBase()
    drawChart(theDataSet, false)
}

export function redrawRadialChart(theDataSet) {
    drawChart(theDataSet, true)
}


// Accessors
const temperatureMinAccessor = d => d.temperatureMin
const temperatureMaxAccessor = d => d.temperatureMax
const uvAccessor = d => d.uvIndex
const cloudAccessor = d => d.cloudCover
const precipitationProbabilityAccessor = d => d.precipProbability
const precipAccumulationAccessor = d => d.precipAccumulation
const precipIntensityAccessor = d => d.precipIntensity
const precipitationTypeAccessor = d => d.precipType
const dateParser = d3.timeParse("%s")
const dateAccessor = d => dateParser(d.dateTime.seconds)


// Scales   
let angleScale

// Helpers
const getCoordinatesForAngle = (angle, offset = 1) => [
    Math.cos(angle - Math.PI / 2) * dimensions.boundedRadius * offset,
    Math.sin(angle - Math.PI / 2) * dimensions.boundedRadius * offset,
]


function setDimensions() {
    // Dimensions
    dimensions = {
        width: vizWitdh,
        height: vizHeigth,
        radius: vizWitdh / 2,
        margin: {
            top: 120,
            right: 120,
            bottom: 120,
            left: 120,
        }
    }
    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom
    dimensions.boundedRadius = dimensions.radius - ((dimensions.margin.left + dimensions.margin.right) / 2)

    // Create a square of the lower value
    const square = d3.extent([dimensions.boundedWidth, dimensions.boundedHeight])
    dimensions.boundedWidth = square[0]
    dimensions.boundedHeight = square[0]
    dimensions.legendWidth = square[0]
}

function drawBase() {
    // create chart area
    wrapper = d3.select(DOMtarget)
        .append("svg")
        .attr("width", dimensions.width)
        .attr("height", dimensions.height)
        .attr("x", 0)
        .attr("y", 0)
        .attr("class", "wrapper")
        .attr("id", "d3-root")





    bounds = wrapper.append("g")
        .style("transform", `translate(${dimensions.margin.left + dimensions.boundedRadius}px, ${dimensions.margin.top + dimensions.boundedRadius}px)`)


    peripherals = bounds.append("g")

    // Source
    const attribution = wrapper.append("a")
        .attr("xlink:href", "https://darksky.net/poweredby/")
        .append("rect")
        .attr("x", 10)
        .attr("y", dimensions.height - 40)
        .attr("height", 40)
        .attr("width", 100)
        .attr("fill", "transparent")
        .attr("opacity", 0.2)


    wrapper.append("text")
        .text("Powered by Dark Sky")
        .style("fill", "black")
        .attr("x", 10)
        .attr("y", dimensions.height - 20)
        .attr("class", "attribution")
        .style("pointer-events", "none")

    defs = wrapper.append("defs")
    gradientId = "temperature-gradient"
    const gradient = defs.append("radialGradient")
        .attr("id", gradientId)
    const numberOfStops = 10
    const gradientColorScale = d3.interpolateYlOrRd
    d3.range(numberOfStops).forEach(i => {
        gradient.append("stop")
            .attr("offset", `${i * 100 / (numberOfStops - 1)}%`)
            .attr("stop-color", gradientColorScale(i / (numberOfStops - 1)))
    })
}


function drawChart(newDataset, redraw) {

    dataset = newDataset

    // Scales
    angleScale = d3.scaleTime()
        .domain(d3.extent(dataset, dateAccessor))
        .range([0, Math.PI * 2]) // this is in radians

    radiusScale = d3.scaleLinear()
        .domain(d3.extent([
            ...dataset.map(temperatureMaxAccessor),
            ...dataset.map(temperatureMinAccessor),
        ]))
        .range([0, dimensions.boundedRadius])
        .nice()

    // Radius stuff
    const getXFromDataPoint = (d, offset = 1.38) => getCoordinatesForAngle(
        angleScale(dateAccessor(d)),
        offset
    )[0]
    const getYFromDataPoint = (d, offset = 1.38) => getCoordinatesForAngle(
        angleScale(dateAccessor(d)),
        offset
    )[1]

    const monthArray = d3.timeMonth.range(...angleScale.domain()).length
    const months = d3.timeMonths(...angleScale.domain())

    const tEnter = d3.transition()
        .duration(1500)
        .ease(d3.easeCubicOut)

    const tEnterDelay = d3.transition()
        .delay(400)
        .duration(1000)
        .ease(d3.easeCubicOut)

    const tEnterSlow = d3.transition()
        .duration(3000)
        .ease(d3.easeCubicIn)

    const tExit = d3.transition()
        .duration(400)
        .ease(d3.easeCubicOut)  // easeBackOut

    // DRAWING

    // MONTH SPIDER NET
    months.forEach(month => {
        const angle = angleScale(month)
        const [x, y] = getCoordinatesForAngle(angle)
        const [labelX, labelY] = getCoordinatesForAngle(angle, 1.38)
        if (redraw == false) {
            peripherals.append("line")
                .attr("x2", x)
                .attr("y2", y)
                .attr("class", "grid-line")
                .attr("stroke", "#dadadd")


            peripherals.append("text")
                .attr("x", labelX)
                .attr("y", labelY)
                .attr("class", "tick-label")
                .text(d3.timeFormat("%b")(month))
                .style("text-anchor",
                    Math.abs(labelX) < 5 ? "middle" :
                        labelX > 0 ? "start" :
                            "end"
                )
        } else {
            // nothing
        }
    })

    // Freezing circle
    const containsFreezing = radiusScale.domain()[0] < 0

    if (containsFreezing) {
        if (redraw == false) {
            freezingCircle = peripherals
                .append("circle")
                .attr("class", "freezing")
                .attr("r", 0)
                .transition(tEnter)
                .attr("r", radiusScale(0))
                .attr("fill", "#00d2d3")
                .attr("opacity", 0.2)
        } else {
            peripherals.select(".freezing")
                .transition(tEnter)
                .attr("r", radiusScale(0))
        }
    }

    // Tick lines and labels
    const temperatureTicks = radiusScale.ticks(6)
    // Remove Spiderweb first
    if (redraw == true) {
        peripherals.selectAll(".radial-line")
            .transition(tExit)
            .remove()

        peripherals.selectAll(".tick-label-back")
            .transition(tExit)
            .remove()

        peripherals.selectAll(".tick-label-temperature")
            .transition(tExit)
            .remove()
    }
    const gridCircles = temperatureTicks.map(d => (
        peripherals
            .append("circle")
            .attr("opacity", 0)
            .transition(tEnterDelay)
            .attr("opacity", 1)
            .attr("r", radiusScale(d))
            .attr("class", "grid-line")
            .attr("class", "radial-line")
            .attr("fill", "transparent")
            .attr("stroke", "#dadadd")

    ))

    const tickLabelBackgrounds = temperatureTicks.map(d => {
        if (!d) return
        return peripherals.append("rect")
            .attr("opacity", 0)
            .transition(tEnterDelay)
            .attr("opacity", 1)
            .attr("y", -radiusScale(d) - 10)
            .attr("class", "tick-label-back")
            .attr("width", 40)
            .attr("height", 20)
            .attr("fill", "#f8f9fa")
            .attr("x", 1)
    })

    const tickLabels = temperatureTicks.map(d => {
        if (!d) return
        return peripherals.append("text")
            .attr("opacity", 0)
            .transition(tEnterDelay)
            .attr("opacity", 1)
            .attr("x", 4)
            .attr("y", -radiusScale(d) + 2)
            .attr("class", "tick-label-temperature")
            .text(`${d3.format(".0f")(d)}°C`)
    })




    const areaGenerator = d3.areaRadial()
        .angle(d => angleScale(dateAccessor(d)))
        .innerRadius(d => radiusScale(temperatureMinAccessor(d)))
        .outerRadius(d => radiusScale(temperatureMaxAccessor(d)))

    if (redraw == true) {
        bounds.selectAll(".area")
            .transition(tExit)
            .attr("opacity", 0)
            .remove()
    }
    const area = bounds.append("path")
        .attr("opacity", 0)
        .transition(tEnterSlow)
        .attr("opacity", 1)
        .attr("d", areaGenerator(dataset))
        .style("fill", `url(#${gradientId})`)
        .attr("class", "area")

    // UV radius
    uvIndexThresholdVeryHigh = 8
    uvIndexThresholdHigh = 6
    let uvGroup = bounds.append("g")
    UvOffset = 0.95



    if (redraw == true) {
        bounds.selectAll(".uv-line")
            .transition(tExit)
            .attr("opacity", 0)
            .remove()
    }

    // very high
    const uv = uvGroup.selectAll("line")
        .data(dataset.filter(d => uvAccessor(d) >= uvIndexThresholdVeryHigh))
        .enter().append("line")
        .attr("class", "uv-line")
        .attr("x1", d => getXFromDataPoint(d, UvOffset))
        .attr("x2", d => getXFromDataPoint(d, UvOffset + 0.1))
        .attr("y1", d => getYFromDataPoint(d, UvOffset))
        .attr("y2", d => getYFromDataPoint(d, UvOffset + 0.1))
        .attr("stroke", "#e80612")
        .attr("stroke-width", 2)
        .attr("opacity", 1)


    // high
    const highUvDays = uvGroup.selectAll("line")
        .data(dataset.filter(d => {
            if (uvAccessor(d) < uvIndexThresholdVeryHigh && uvAccessor(d) >= 6) {
                return uvAccessor(d)
            }
        }))
        .enter().append("line")
        .attr("class", "uv-line")
        .attr("x1", d => getXFromDataPoint(d, UvOffset))
        .attr("x2", d => getXFromDataPoint(d, UvOffset + 0.1))
        .attr("y1", d => getYFromDataPoint(d, UvOffset))
        .attr("y2", d => getYFromDataPoint(d, UvOffset + 0.1))
        .attr("stroke", "#feca57")
        .attr("stroke-width", 2)


    // CLOUD COVERAGE
    const cloudRadiusScale = d3.scaleSqrt()
        .domain(d3.extent(dataset, cloudAccessor))
        .range([1, 5])

    let cloudGroup = bounds.append("g")
    cloudOffset = 1.27


    if (redraw == true) {
        bounds.selectAll(".cloud-dot")
            .transition(tExit)
            .attr("opacity", 0)
            .remove()

            bounds.selectAll(".precipitation-dot")
            .transition(tExit)
            .attr("opacity", 0)
            .remove()
    }

    const cloudDots = cloudGroup.selectAll("circle")
        .data(dataset)
        .enter().append("circle")
        .attr("class", "cloud-dot")
        .attr("cx", d => getXFromDataPoint(d, cloudOffset))
        .attr("cy", d => getYFromDataPoint(d, cloudOffset))
        .attr("r", d => cloudRadiusScale(cloudAccessor(d)))
        .attr("fill", "#c8d6e5")
        .attr("opacity", 0)
        .transition(tEnter)
        .attr("opacity", d => cloudAccessor(d))

    const snowRadiusScale = d3.scaleSqrt()
        .domain(d3.extent(dataset, precipAccumulationAccessor))
        .range([1, 8])

    const rainRadiusScale = d3.scaleSqrt()
        .domain(d3.extent(dataset, precipIntensityAccessor))
        .range([1, 8])

    precipitationTypes = ["rain", "sleet", "snow"]
    precipitationTypeColorScale = d3.scaleOrdinal()
        .domain(precipitationTypes)
        .range(["#54a0ff", "#636e72", "#b2bec3"])


    const precipitationGroup = bounds.append("g")
    precipitationOffset = 1.14



    let precipitationDots = precipitationGroup.selectAll("circle")
        .data(dataset.filter(precipitationTypeAccessor))

    precipitationDots.enter().append("circle")
        .attr("class", "precipitation-dot")
        .attr("cx", d => getXFromDataPoint(d, precipitationOffset))
        .attr("cy", d => getYFromDataPoint(d, precipitationOffset))
        .attr("r", d => {
            if (precipitationTypeAccessor(d) == "snow") {
                return snowRadiusScale(precipAccumulationAccessor(d))
            } else {
                return rainRadiusScale(precipIntensityAccessor(d))
            }
        })
        .style("fill", d => precipitationTypeColorScale(precipitationTypeAccessor(d)))
        .attr("opacity", 0)
        .transition(tEnter)
        .attr("opacity", 0.6)


    // ROLLOVER

    const listenerCircle = bounds.append("circle")
        .attr("class", "listener-circle")
        .attr("r", dimensions.width / 2)
        .attr("fill", "transparent")
        .on("mousemove", onMouseMove)
        .on("mouseleave", onMouseLeave)


    const tooltip = d3.select("#tooltip")
    const tooltipLine = bounds.append("path")
        .attr("class", "tooltip-line")
        .style("opacity", 0.2)


    function onMouseMove(e) {

        const tooltipradius = 1.3
        const tooltipBoxradius = 0.45

        tooltipLine
            .style("opacity", 0.2)

        const [x, y] = d3.mouse(this)
        const getAngleFromCoordinates = (x, y) => Math.atan2(y, x)
        let angle = getAngleFromCoordinates(x, y) + Math.PI / 2
        if (angle < 0) angle = (Math.PI * 2) + angle

        const tooltipArcGenerator = d3.arc()
            .innerRadius(0)
            .outerRadius(dimensions.boundedRadius * tooltipradius)
            .startAngle(angle - 0.0098)
            .endAngle(angle + 0.0098)

        tooltipLine.attr("d", tooltipArcGenerator())

        // TOOLTIP BOX
        const outerCoordinates = getCoordinatesForAngle(angle + Math.PI, tooltipBoxradius)

        // radius
        let xTrans = outerCoordinates[0] + dimensions.boundedWidth / 2 + dimensions.margin.top
        let yTrans = outerCoordinates[1] + dimensions.boundedHeight / 2 + dimensions.margin.left

        // center tooltip
        let TTrect = tooltip.node().getBoundingClientRect()
        xTrans = xTrans - TTrect.width / 2
        yTrans = yTrans - TTrect.height / 2


        tooltip.style("opacity", 1)
            .style("transform", `translate(${xTrans}px,${yTrans}px)`)


        const date = angleScale.invert(angle)
        const dateString = d3.timeFormat("%Y-%m-%d")(date)

        // adapt to our date time stuff
        const dataPoint = dataset.filter(d => {
            let cDate = d3.timeFormat("%Y-%m-%d")(d.dateTime.seconds * 1000)
            if (cDate == dateString) {
                return cDate
            }
        })[0]

        if (!dataPoint) return

        tooltip.select("#tooltip-date")
            .text(d3.timeFormat("%B %-d")(date))
        tooltip.select("#tooltip-temperature-min")
            .html(`${d3.format(".1f")(temperatureMinAccessor(dataPoint))}°C`)
        tooltip.select("#tooltip-temperature-max")
            .html(`${d3.format(".1f")(temperatureMaxAccessor(dataPoint))}°C`)
        tooltip.select("#tooltip-uv")
            .text(uvAccessor(dataPoint))
        tooltip.select("#tooltip-cloud")
            .text(cloudAccessor(dataPoint))
        tooltip.select("#tooltip-precipitation")
            .text(precipitationTypeAccessor(dataPoint) == "snow" ?
                d3.format(".1f")(precipAccumulationAccessor(dataPoint)) + "cm" :
                d3.format(".2f")(precipIntensityAccessor(dataPoint)) + "mm/h"
            )
        tooltip.select(".tooltip-precipitation")
            .style("color", precipitationTypeAccessor(dataPoint)
                ? precipitationTypeColorScale(precipitationTypeAccessor(dataPoint))
                : "#dadadd")
        tooltip.select("#tooltip-precipitation-type")
            .text(precipitationTypeAccessor(dataPoint))
        tooltip.select(".tooltip-precipitation-type")
            .style("color", precipitationTypeAccessor(dataPoint)
                ? precipitationTypeColorScale(precipitationTypeAccessor(dataPoint))
                : "#dadadd")
        tooltip.select("#tooltip-temperature-min")
            .style("color", radiusScale(temperatureMinAccessor(dataPoint)))
        tooltip.select("#tooltip-temperature-max")
            .style("color", radiusScale(temperatureMaxAccessor(dataPoint)))
    }






    function onMouseLeave() {
        tooltip.style("opacity", 0)
        tooltipLine.style("opacity", 0)
    }
    if (redraw == false) {
        drawAnotation()
    }
}

function drawAnotation() {

    const annotationGroup = bounds.append("g")

    const drawAnnotation = (angle, offset, text) => {
        const [x1, y1] = getCoordinatesForAngle(angle, offset)
        const [x2, y2] = getCoordinatesForAngle(angle, 1.6)

        annotationGroup.append("line")
            .attr("class", "annotation-line")
            .attr("x1", x1)
            .attr("x2", x2)
            .attr("y1", y1)
            .attr("y2", y2)
            .attr("stroke", "#34495e")
            .attr("opacity", 0.4)

        annotationGroup.append("text")
            .attr("class", "annotation-text")
            .attr("x", x2 + 6)
            .attr("y", y2)
            .text(text)
    }

    drawAnnotation(Math.PI * 0.23, cloudOffset, "Cloud Cover")
    drawAnnotation(Math.PI * 0.26, precipitationOffset, "Precipitation")

    drawAnnotation(Math.PI * 1.12, UvOffset + 0.05, "UV Index over >6-7 (yellow) / 8-10 (red)")
    drawAnnotation(Math.PI * 0.85, 0.5, "Temperature")
    drawAnnotation(Math.PI * 0.8, radiusScale(0) / dimensions.boundedRadius, "Freezing Temperatures")


    precipitationTypes.forEach((precipitationType, index) => {
        const labelCoordinates = getCoordinatesForAngle(Math.PI * 0.26, 1.6)
        annotationGroup.append("circle")
            .attr("cx", labelCoordinates[0] + 15)
            .attr("cy", labelCoordinates[1] + (16 * (index + 1)))
            .attr("r", 4)
            .style("opacity", 0.7)
            .attr("fill", precipitationTypeColorScale(precipitationType))
        annotationGroup.append("text")
            .attr("class", "annotation-text")
            .attr("x", labelCoordinates[0] + 25)
            .attr("y", labelCoordinates[1] + (16 * (index + 1)))
            .text(precipitationType)
    })


}


